module.exports = __webpack_public_path__ + "img/ic_medal (1).42ceca54.png";